import React, { useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import i18n from '../../i18n';
import { NOT_CREATED_ALERT, CREATED_ALERT_LABEL_INVISIBLE } from '../../models/PushAlert';
import Push from './Push';

export default function PushAlert(props) {
    const { title, text, renderIcon, onPush, onHide, className } = props;
    const [status, setStatus] = useState(NOT_CREATED_ALERT);

    useEffect(() => {
        if (props.status) {
            setStatus(props.status);
        }
    }, [props.status]);

    const displayAlertCreated = () => {
        setTimeout(() => {
            setStatus(CREATED_ALERT_LABEL_INVISIBLE);
            if (onHide) {
                onHide();
            }
        }, 3000);

        return (
            <div className="push-alert-created">
                <i className="icon-check" />
                <span className="push-alert-created-text">{i18n.t('search:no-results.alert-success')}</span>
            </div>
        );
    };

    const renderButton = useCallback(
        () =>
            status === NOT_CREATED_ALERT ? (
                <button className="push-button btn btn-default" onClick={onPush}>
                    {i18n.t('search:no-results.alert-button')}
                </button>
            ) : (
                displayAlertCreated()
            ),
        [status]
    );

    return (
        status !== CREATED_ALERT_LABEL_INVISIBLE && (
            <Push
                className={`push-alert ${className}`}
                title={title}
                text={text}
                renderIcon={renderIcon}
                renderButton={renderButton}
                {...props}
            />
        )
    );
}

PushAlert.propTypes = {
    title: PropTypes.string,
    text: PropTypes.string,
    renderIcon: PropTypes.func,
    status: PropTypes.string,
    onPush: PropTypes.func,
    onHide: PropTypes.func,
    className: PropTypes.string
};
